export default __webpack_public_path__ + "static/media/ProximaNova-Reg.f85ec2ca.woff";